import React from "react";
import { useSelector } from "react-redux";
import MenuMobileNavItem from "./MenuMobileNavItem";
import MobileExpandableMenu from "../mobileExpandableMenu/MobileExpandableMenu";
import pathRouts from "../../../../shared/enums/pathRoute";
import MENUTABS from "../../../constants/menuTabs";

const MenuMobile = ({ dynamicTabs }) => {

    const { texts } = useSelector(state => state.translate);

    return (
        <MobileExpandableMenu>
            {MENUTABS.filter(tab => tab.route !== pathRouts.HOME).map(tab => (
                <MenuMobileNavItem
                    key={tab.route}
                    title={texts[tab.titleKey]}
                    icon={tab.icon}
                    to={`/${tab.route}`}
                />
            ))}
            {dynamicTabs?.map(tab => (
                <MenuMobileNavItem key={tab.key} title={texts[tab.titleKey]} icon={tab.icon} to={tab.route} />
            ))}
        </MobileExpandableMenu>
    );
};

export default MenuMobile;
